/** @jsxImportSource @emotion/react */

import tw from "twin.macro";
import { sideFormatter } from "utils/helpers";

import { MsagChangeResponse } from "../../services/DiscrepancyType";

const MsagChangeTable: React.FC<MsagChangeResponse> = ({
  msag,
  msag_change,
}) => {
  const msagData = [
    {
      key: "Low Range",
      original: msag_change.ORG_LowRange,
      requested: msag_change.EDIT_LowRange,
      current: msag && msag.LowRange,
    },
    {
      key: "High Range",
      original: msag_change.ORG_HiRange,
      requested: msag_change.EDIT_HiRange,
      current: msag && msag.HiRange,
    },
    {
      key: "Side",
      original: msag_change.ORG_Side,
      requested: msag_change.EDIT_Side,
      current: msag && sideFormatter(msag.Side),
    },
    {
      key: "Prefix Directional",
      original: msag_change.ORG_PRD,
      requested: msag_change.EDIT_PRD,
      current: msag && msag.PrefixDir,
    },
    {
      key: "Street Name",
      original: msag_change.ORG_STN,
      requested: msag_change.EDIT_STN,
      current: msag && msag.StreetName,
    },
    {
      key: "Street Suffix",
      original: msag_change.ORG_STS,
      requested: msag_change.EDIT_STS,
      current: msag && msag.StreetSuffix,
    },
    {
      key: "Post Directional",
      original: msag_change.ORG_POD,
      requested: msag_change.EDIT_POD,
      current: msag && msag.PostDir,
    },
    {
      key: "MSAG Community Name",
      original: msag_change.ORG_MCN,
      requested: msag_change.EDIT_MCN,
      current: msag && msag.MCN,
    },
    {
      key: "State",
      original: msag_change.ORG_STA,
      requested: msag_change.EDIT_STA,
      current: msag && msag.State,
    },
    {
      key: "Community",
      original: msag_change.ORG_MCN,
      requested: msag_change.EDIT_MCN,
      current: msag && msag.MCN,
    },
    {
      key: "County ID",
      original: msag_change.EDIT_CountyID,
      requested: msag_change.EDIT_CountyID,
      current: msag && msag.CountyID,
    },
    {
      key: "ESN",
      original: msag_change.ORG_esn,
      requested: msag_change.EDIT_esn,
      current: msag && msag.esn,
    },
  ];

  return (
    <>
      <h3 css={[tw`mb-2`]}>Changes to MSAG ID {msag.id}</h3>
      <div
        css={[
          tw`col-span-2 overflow-hidden min-h-full border border-gray-400 rounded-md`,
        ]}
      >
        <table css={[tw`w-full`]}>
          <thead css={[tw`bg-gray-200 border-b border-gray-400`]}>
            <tr css={[tw`text-left`]}>
              <th css={[tw`border-r border-gray-400 p-2`]}></th>
              <th css={[tw`font-semibold border-r border-gray-400 p-2`]}>
                Original
              </th>
              <th css={[tw`border-r border-gray-400 font-semibold p-2`]}>
                Requested
              </th>
              <th css={[tw`font-semibold p-2`]}>Current</th>
            </tr>
          </thead>
          <tbody>
            {msagData.map((row) => (
              <tr
                key={row.key}
                css={[
                  tw`border-b border-gray-300`,
                  (row.original !== row.requested ||
                    row.current !== row.requested) &&
                    row.current !== null &&
                    tw`bg-yellow-600`,
                ]}
              >
                <td
                  css={[tw`font-semibold border-r border-gray-400 p-2 w-1/4`]}
                >
                  {row.key}
                </td>
                <td css={[tw`border-r border-gray-400 p-2 w-1/4`]}>
                  {row.original}
                </td>
                <td css={[tw`border-r border-gray-400 p-2 w-1/4`]}>
                  {row.requested}
                </td>
                <td css={[tw`p-2 w-1/4`]}>{row.current}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default MsagChangeTable;
